import React, { useEffect, useState } from 'react';
import './Navbar.css';

const links = ['experience', 'projects', 'skills', 'certifications', 'languages', 'contact'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-logo mono">Portfolio</div>
      <ul className="nav-links">
        {links.map((l) => (
          <li key={l}>
            <a href={`#${l}`}>{l}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
